var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivityHistoryDatePicker = function SvgActivityHistoryDatePicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5.48h-4.808V4h-1.145v1.476l-7.11.001V4H7.293v1.476L2.5 5.477V20h19V5.48ZM7.308 6.529v.85h1.145v-.867h7.11v.85h1.145v-.85h3.681v2.497H3.627V6.512l3.68.017ZM3.627 18.964v-8.92h16.746v8.92H3.627Z",
    fill: "#666"
  })));
};
export default SvgActivityHistoryDatePicker;